<div [class]="'default-notification ' + modify" [attr.data-test-element]="mode">
  <button class="default-notification__close" (click)="closeFn()" aria-label="close notification">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512">
      <path fill="currentColor" d="M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"/>
    </svg>
  </button>
  <div class="default-notification__title">{{title}}</div>
  <span class="divider" *ngIf="isDivider"></span>
  <p class="default-notification__description">
    {{description}}
    <span *ngIf="addedDescription"> : {{ addedDescription }}</span>
  </p>
  <div class="template">
    <ng-container *ngTemplateOutlet="template; context: {$implicit: templatePayload}"></ng-container>
  </div>
</div>
